<template>
  <div class="col-24">
    <b-modal
      size="xl"
      centered
      no-close-on-backdrop
      ok-title="Enviar"
      id="modal-edit-scope"
      ref="modalEdit"
      modal
      @hide="closeModalScope"
      :title="activeEditScope ? $ml.get('editScope') : $ml.get('scopeDetails')"
    >
      <div class="card card-body d-flex w-100">
        <div class="row w-100 d-flex align-items-center mb-4">
          <div class="col pr-3 pb-2">
            <input
              maxlength="100"
              type="text"
              class="form-control"
              v-model="txtScop"
              :placeholder="$ml.get('informTheScope')"
            />
            <transition name="fade">
              <label
                v-if="validateScopeError && !$v.txtScop.required"
                class="lblError"
                v-text="$ml.get('theScopeAddressMustBeInformed')"
                >Informe o endereço do escopo</label
              >
              <label
                class="lblError"
                v-text="$ml.get('minMaxScopeCaracter')"
                v-if="validateScopeError && !$v.txtScop.minLength"
                >O escopo deve ter entre 3 e 40 caracteres</label
              >
            </transition>
          </div>

          <div
            :class="
              'pr-3 pb-2 col-22 ' +
              (typeProgram != 'vdp'
                ? 'col-lg-7 col-md-12'
                : 'col-lg-10 col-md-12')
            "
            class=""
          >
            <multiselect
              v-model="selectedScopeType"
              label=""
              :custom-label="nameLang"
              :options="selectScopeType"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :placeholder="$ml.get('scopeType')"
            >
            </multiselect>
            <transition name="fade">
              <label
                v-if="validateScopeError && !$v.selectedScopeType.required"
                class="lblError"
                v-text="$ml.get('selectScopeType')"
                >Selecione o tipo de escopo</label
              >
            </transition>
          </div>

          <div class="col-lg-5 col-md-8 pr-3 pb-2 col-22">
            <multiselect
              v-model="selectedImpact"
              label="name"
              :custom-label="({ name }) => `${nameLang(name)}`"
              :options="selectImpact"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :placeholder="$ml.get('severity')"
            >
            </multiselect>
          </div>

          <div
            v-if="typeProgram != 'vdp'"
            class="col-lg-4 col-md-6 col-22 pb-2"
          >
            <multiselect
              v-model="selectedElegivel"
              label="name"
              :custom-label="({ name }) => `${nameLang(name)}`"
              :options="offers_bounty"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              :placeholder="'Bounty'"
            >
            </multiselect>
            <transition name="fade">
              <label
                v-if="validateScopeError && !$v.selectedElegivel.required"
                class="lblError"
                v-text="$ml.get('requiredField')"
                >Campo obrigatório</label
              >
            </transition>
          </div>
        </div>
        <div class="col">
          <textarea
            class="form-control-textarea w-100"
            name="scopeDetails"
            id=""
            cols="30"
            rows="5"
            v-model="scopeDetails"
            maxlength="300"
            :placeholder="$ml.get('includeInfoScope')"
          ></textarea>
          <div v-if="maxRowsError">
            <label class="lblError" v-text="$ml.get('maxLine')"
              >Por favor, limite a mensagem a no máximo 10 quebras de
              linha.</label
            >
          </div>
          <div class="col-24 d-flex justify-content-end">
            <span style="font-size: 12px; color: #525252; font-weight: 400"
              >{{ $ml.get("characters") }} {{ scopeDetails.length }}/300</span
            >
          </div>
        </div>

        <div class="mt-4">
          <div class="d-flex align-items-center" style="gap: 10px">
            <input
              type="text"
              v-model="tag"
              class="form-control"
              :placeholder="$ml.get('includeTech')"
            />
            <button
              @click="addTag"
              class="btn"
              :disabled="!tag"
              v-text="$ml.get('include')"
            >
              Incluir
            </button>
          </div>
          <div class="col-24 mb-2">
            <label
              v-if="errorLimitTag"
              class="lblError"
              v-text="$ml.get('maxTech')"
              >O máximo permitido é de 10 tecnologias por escopo.</label
            >
          </div>
        </div>
        <div
          v-if="tagList.length"
          class="d-flex align-items-center mt-3"
          style="gap: 10px; flex-wrap: wrap"
        >
          <div v-for="(tag, index) in tagList" :key="index">
            <div class="scope_tag">
              <span>{{ tag }}</span>
              <div @click="removeTags(tag)" class="close">X</div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{}">
        <b-button
          class="float-right btn"
          style="background: #730ba9; border: none"
          size="sm"
          variant="primary"
          @click="activeEditScope ? savePlan() : verifyPlan()"
        >
          {{ activeEditScope ? $ml.get("save") : $ml.get("add") }}
        </b-button>
        <b-button
          class="float-right btn-outline-extra"
          size="sm"
          variant="primary"
          @click="closeModalScope"
        >
          {{ $ml.get("toClose") }}
        </b-button>
      </template>
    </b-modal>
    <div class="d-flex align-self-start">
      <div
        class="position-relative align-self-center d-flex align-items-center align-self-center"
      >
        <div
          class="circle-number d-flex justify-content-center align-items-center"
        >
          <span>{{ number }}</span>
        </div>
      </div>
      <div class="pl-3 d-flex">
        <div class="align-self-start mt-1">
          <h2 class="size-1_4 m-0 pb-1">
            <strong v-text="$ml.get('scope')">Escopo</strong>
          </h2>
          <p class="d-flex align-items-center">
            <span class="align-self-center" v-text="$ml.get('limitScope')">
              Delimite o escopo e somente os acessos que serão recopensados!
            </span>
          </p>
        </div>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>
      <div class="d-flex flex-column w-100 mr-3" style="position: relative">
        <p class="pl-3 mb-3" v-text="$ml.get('delimitDomains')">
          Delimite domínios, subdomínios, aplicativos e outros
        </p>
        <div class="d-flex pl-3 w-100">
          <div class="row w-100 d-flex" style="flex-wrap: wrap; gap: 5px">
            <div class="col-lg-7 col-md-7 pr-3 pb-2 col-24 minInput">
              <input
                maxlength="100"
                type="text"
                class="form-control"
                v-model="txtScop"
                :placeholder="$ml.get('informTheScope')"
              />
              <transition name="fade">
                <div class="mb-2">
                  <label
                    v-if="validateScopeError && !$v.txtScop.required"
                    class="lblError"
                    v-text="$ml.get('theScopeAddressMustBeInformed')"
                    >Informe o endereço do escopo</label
                  >
                  <label
                    class="lblError"
                    v-text="$ml.get('minMaxScopeCaracter')"
                    v-if="validateScopeError && !$v.txtScop.minLength"
                    >O escopo deve ter entre 3 e 40 caracteres</label
                  >
                </div>
              </transition>
            </div>

            <div
              :class="
                'pr-3 pb-2 col-24 minInput ' +
                (typeProgram != 'vdp'
                  ? 'col-lg-5 col-md-5'
                  : 'col-lg-5 col-md-5')
              "
              class=""
            >
              <multiselect
                v-model="selectedScopeType"
                label=""
                :custom-label="nameLang"
                :options="selectScopeType"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :placeholder="$ml.get('scopeType')"
              >
              </multiselect>
              <transition name="fade">
                <div class="mb-2">
                  <label
                    v-if="validateScopeError && !$v.selectedScopeType.required"
                    class="lblError"
                    v-text="$ml.get('selectScopeType')"
                    >Selecione o tipo de escopo</label
                  >
                </div>
              </transition>
            </div>

            <div class="col-lg-5 col-md-8 pr-3 pb-2 col-24 minInput">
              <multiselect
                v-model="selectedImpact"
                label="name"
                :custom-label="({ name }) => `${nameLang(name)}`"
                :options="selectImpact"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :placeholder="$ml.get('severity')"
              >
              </multiselect>
            </div>

            <div
              v-if="typeProgram != 'vdp'"
              class="col-lg-4 col-md-6 col-24 pb-2 pr-3 minInput"
            >
              <multiselect
                v-model="selectedElegivel"
                label="name"
                :custom-label="({ name }) => `${nameLang(name)}`"
                :options="offers_bounty"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :placeholder="'Bounty'"
              >
              </multiselect>
              <transition name="fade">
                <div class="mb-2">
                  <label
                    v-if="validateScopeError && !$v.selectedElegivel.required"
                    class="lblError"
                    v-text="$ml.get('requiredField')"
                    >Campo obrigatório</label
                  >
                </div>
              </transition>
            </div>
            <div class="col d-flex justify-content-end mr-2 pointer">
              <button
                v-if="!activeEditScope"
                style="height: 38.99px"
                class="btn"
                @click="verifyPlan()"
                v-text="$ml.get('include')"
              >
                Incluir
              </button>
            </div>
          </div>
        </div>
        <div class="ml-3 d-flex w-100 mb-2 pr-3 mb-3">
          <a
            class="moreInfo"
            v-b-modal.modal-edit-scope
            v-text="$ml.get('includeMoreDetails')"
            >Acrescentar mais detalhes...</a
          >
        </div>
        <div class="card card-body ml-3 p-0 d-flex w-100">
          <div v-if="!listScop.length" class="d-flex justify-content-center">
            <h6
              :class="
                validateError && !$v.listScop.required
                  ? 'size-1_4 p-4 text-danger'
                  : 'size-1_4 p-4 '
              "
              v-text="$ml.get('addTheScopesHere')"
            >
              Adicione os escopos aqui!
            </h6>
          </div>
          <table v-else v-show="listScop.length" class="mb-2">
            <thead>
              <tr>
                <th class="col-9" v-text="$ml.get('scope')">Escopo</th>
                <th
                  :class="'pl-0 ' + (typeProgram != 'vdp' ? 'col-5' : 'col-9')"
                  v-text="$ml.get('type')"
                >
                  Tipo
                </th>
                <th class="col-4 pl-0" v-text="$ml.get('severity')">Tipo</th>
                <th v-if="typeProgram != 'vdp'" class="col-5 pl-0">Bounty</th>
                <th class="col-2"></th>
                <th class="col-2"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in listScop" :key="index">
                <td class="col-9 text-break">
                  <p class="m-0">
                    <strong>{{ item.description }}</strong>
                  </p>
                  <br />
                  <div v-if="item.scope_details" style="max-width: 380px">
                    <p style="white-space: pre-wrap">
                      {{ item.scope_details }}
                    </p>
                  </div>
                  <div
                    v-if="item?.scope_tags"
                    class="d-flex align-items-center"
                    style="gap: 10px; flex-wrap: wrap"
                  >
                    <div v-for="(tag, index) in item.scope_tags" :key="index">
                      <div class="scope_tag">{{ tag }}</div>
                    </div>
                  </div>
                </td>
                <td
                  :class="
                    'pl-0 text-muted ' +
                    (typeProgram != 'vdp' ? 'col-5' : 'col-9')
                  "
                >
                  {{ nameLang(item.type) }}
                </td>
                <td class="col-4 pl-0 ">
                  <Impact
                    class="d-flex pt-1"
                    :impact="'impact-' + item.severity"
                  />
                </td>

                <td
                  v-if="typeProgram != 'vdp'"
                  class="col-4 pl-0 "
                >
                  <div v-if="item.offers_bounty" class="row">
                    <img
                      class="img-money"
                      src="../../../assets/images/money.png"
                    />
                    <strong
                      class="text-success align-items-center d-none d-md-flex"
                      v-text="$ml.get('eligible')"
                      >Elegivel</strong
                    >
                  </div>
                  <div v-if="!item.offers_bounty" class="row">
                    <img
                      class="img-money"
                      src="../../../assets/images/no-money.png"
                    />
                    <strong
                      class="text-danger align-items-center d-none d-md-flex"
                      v-text="$ml.get('notEligible')"
                      >Inelegivel</strong
                    >
                  </div>
                </td>

                <td
                  class="col-2 pl-0 d-flex justify-content-end"
                  style="gap: 10px"
                >
                  <a
                    v-b-modal.modal-edit-scope
                    class="pointer"
                    @click="editScop(item, index)"
                  >
                    <svg width="16" height="16">
                      <image
                        xlink:href="../../../../src/assets/icons/edit.png"
                        width="16"
                        height="16"
                      />
                    </svg>
                  </a>
                  <a class="pointer" @click="removeScop(index)">
                    <svg width="16" height="16">
                      <image
                        xlink:href="../../../../src/assets/icons/trash-alt.svg"
                        width="16"
                        height="16"
                      />
                    </svg>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-5"></span>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import { minLength, required } from "vuelidate/lib/validators";
// import PlanService from "../../../services/plan.service";

export default {
  name: "Scope",
  props: {
    number: {
      type: String,
      required: true,
    },
    typeProgram: {
      type: String,
      required: true,
    },
    listScop: {
      type: Array,
      required: true,
      default: Array,
    },
    listScopRemove: {
      type: Array,
      required: false,
      default: Array,
    },
    validateError: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {},
  data() {
    return {
      activeEditScope: false,
      idEditScope: null,
      scopeDetails: "",
      maxRowsError: "",
      errorLimitTag: "",
      validateScopeError: false,
      txtScop: "",
      tag: "",
      tagList: [],
      selectedScopeType: "",
      selectedImpact: null,
      selectedElegivel: null,

      selectScopeType: [
        "url",
        "web",
        "api",
        "mobile-application-android",
        "mobile-application-ios",
        "domain",
        "subdomain",
        "ip",
        "other",
      ],

      selectImpact: [
        { id: "none", name: "-" },
        { id: "low", name: "low" },
        { id: "medium", name: "medium" },
        { id: "high", name: "high" },
        { id: "critical", name: "critical" },
      ],

      offers_bounty: [
        { id: true, name: "eligible" },
        { id: false, name: "notEligible" },
      ],
      scopeMaxLengt: false,
    };
  },
  validations: {
    txtScop: { required, minLength: minLength(3) },
    selectedScopeType: { required },
    selectedElegivel: { required },
    listScop: { required },
  },

  watch: {
    scopeDetails() {
      this.maxRowsError = "";
    },
    tagList() {
      this.errorLimitTag = "";
    },
  },
  methods: {
    addTag() {
      if (this.tagList.includes(this.tag)) return;

      const maxTags = 9;
      if (this.tagList.length > maxTags) {
        this.errorLimitTag = "ERROR";
        return;
      }

      this.tagList = [...this.tagList, this.tag];
      this.tag = "";
    },

    removeTags(tag) {
      this.tagList = this.tagList.filter(
        (t) => t.toUpperCase() != tag.toUpperCase(),
      );
    },

    editScop(element, idx) {
      const objSeverity = {
        undefined: {
          id: "none",
          name: "-",
        },
        none: {
          id: "none",
          name: "-",
        },
        low: {
          id: "low",
          name: "low",
        },
        medium: {
          id: "medium",
          name: "medium",
        },
        high: {
          id: "high",
          name: "high",
        },
        critical: {
          id: "critical",
          name: "critical",
        },
      };

      this.activeEditScope = true;
      this.idEditScope = idx;

      this.tagList = element.scope_tags ?? [];
      this.scopeDetails = element.scope_details ?? "";

      this.txtScop = element.description ?? "";
      this.selectedScopeType = element.type ?? "";
      this.selectedImpact = objSeverity[element.severity];
      this.selectedElegivel = element.offers_bounty
        ? { id: true, name: "eligible" }
        : { id: true, name: "notEligible" };
    },

    savePlan() {
      var self = this;
      const maxRows = 9;
      const qntRows = self.scopeDetails.split("\n").length - 1;
      if (qntRows > maxRows) {
        self.maxRowsError = "ERROR";
        return;
      }

      this.listScop[this.idEditScope].description = this.txtScop;
      this.listScop[this.idEditScope].scope_details = this.scopeDetails;
      this.listScop[this.idEditScope].scope_tags = this.tagList;
      this.listScop[this.idEditScope].type = this.selectedScopeType;
      this.listScop[this.idEditScope].severity = this.selectedImpact.id;
      this.listScop[this.idEditScope].offers_bounty =
        this.typeProgram != "vdp" ? this.selectedElegivel.id : false;

      this.closeModalScope();
    },

    closeModalScope() {
      this.tag = "";
      this.txtScop = "";
      this.scopeDetails = "";
      this.tagList = [];
      this.selectedScopeType = "";
      this.selectedImpact = null;
      this.selectedElegivel = {
        id: "none",
        name: "-",
      };

      this.activeEditScope = false;
      this.idEditScope = null;

      this.$refs.modalEdit.hide();
    },
    // Altera o idioma dos itens do select
    nameLang(name) {
      if (!["-"].includes(name) && name) {
        return this.$ml.get(name.replaceAll("-", ""));
      }
      return name;
    },

    async verifyPlan() {
      var self = this;
      // stop here if form is invalid
      this.$v.$touch();
      if (
        this.$v.txtScop.$error ||
        this.$v.selectedScopeType.$error ||
        (this.$v.selectedElegivel.$error && this.typeProgram != "vdp")
      ) {
        this.validateScopeError = true;
        return;
      }

      self.addScop();
    },

    async addScop() {
      var self = this;

      const maxRows = 9;
      const qntRows = self.scopeDetails.split("\n").length - 1;
      if (qntRows > maxRows) {
        self.maxRowsError = "ERROR";
        return;
      }

      let newItem = {
        description: this.txtScop,
        scope_details: this.scopeDetails,
        scope_tags: this.tagList,
        type: this.selectedScopeType,
        severity: this.selectedImpact ? this.selectedImpact.id : "none",
        offers_bounty:
          this.typeProgram != "vdp" ? this.selectedElegivel.id : false,
      };
      this.scopeDetails = "";
      this.tagList = [];

      let diference = false;

      this.closeModalScope();

      await this.listScop.forEach((element) => {
        if (element.description === newItem.description) {
          Swal.fire({
            icon: "info",
            title: "",
            text: self.$ml.get("cannotEnterEqualScopes"),
          });
          diference = true;
          return;
        }

        if (JSON.stringify(element) === JSON.stringify(newItem)) {
          Swal.fire({
            icon: "info",
            title: "",
            text: self.$ml.get("cannotEnterEqualScopes"),
          });
          diference = true;
          return;
        }
      });

      this.validateScopeError = false;
      if (!diference) {
        this.txtScop = "";
        this.selectedScopeType = null;
        this.selectedImpact = null;
        this.selectedElegivel = null;
        this.listScop.push(newItem);
      }
    },

    removeScop(item) {
      this.listScop[item].status = "inactive";
      this.listScopRemove.push(this.listScop[item]);
      this.listScop.splice(item, 1);
    },
  },
};
</script>
<style scoped>
.close {
  cursor: pointer;
  color: #8a0ba9;
  font-weight: 500;
  font-size: 0.6rem;
}
.close:hover {
  color: #390546;
}
* {
  scrollbar-width: thin;
  scrollbar-color: #9b9b9b #f1f1f1;
}
.moreInfo {
  cursor: pointer;
  font-weight: 400;
  color: #730ba9;
  transition: all 0.2s;
}
.moreInfo:hover {
  color: #b21fcc !important;
}
.minInput {
  min-width: 180px;
}
</style>
